module.exports = window.dnn.Users.CommonActions;